import React from 'react';

interface InfosCustomersDefaultProps {
  customerIDSelect?: string | null;
}

const InfosCustomersDefault: React.FC<InfosCustomersDefaultProps> = () => {
  return null;
};

export default InfosCustomersDefault;
